import { useState } from 'react'

import { useUserStore } from 'core/hooks/services/useUserStore'

export function useUserAuthorize() {
  const { hpLogin } = useUserStore()
  const [errorMessage, setErrorMessage] = useState('')
  const clearErrorMessage = () => setErrorMessage('')

  const proceedToAuth = async () => {
    const redirectUrl = '/simple_partner_search'

    const result = await hpLogin(redirectUrl)
    if (!result) {
      setErrorMessage('Login failed because HPID is not available now. Please try again later')
    } else {
      window.location.replace(result)
    }
  }

  return {
    errorMessage,
    clearErrorMessage,
    proceedToAuth,
  }
}
